import React from "react";
import { ArrowDown } from "lucide-react";

// Lot 776 — petits éléments du fil « comme un chat » : repère « Nouveaux messages », pastille « N nouveaux ↓ », badge non lus.
export const UnreadDivider = ({ label = "Nouveaux messages", testId = "thread-unread-divider" }) => (
  <div className="flex items-center gap-2 text-[10px] font-semibold uppercase tracking-wide py-1" style={{ color: "var(--yalola-primary)" }} data-testid={testId} role="separator" aria-label={label}>
    <span className="flex-1 h-px" style={{ background: "var(--yalola-primary)", opacity: 0.4 }} />
    {label}
    <span className="flex-1 h-px" style={{ background: "var(--yalola-primary)", opacity: 0.4 }} />
  </div>
);

export const NewBelowPill = ({ count, onClick, label, testId = "thread-new-below" }) => {
  if (!count) return null;
  const text = (label || "{n} nouveau(x) message(s)").replace("{n}", String(count));
  return (
    <button type="button" onClick={onClick} className="absolute left-1/2 -translate-x-1/2 bottom-3 pill pill-primary text-xs inline-flex items-center gap-1 shadow-md whitespace-nowrap" data-testid={testId} data-count={count}>
      <ArrowDown size={12} /> {text}
    </button>
  );
};

export const UnreadBadge = ({ count, label, testId }) => {
  if (!count) return null;
  const text = (label || "{n} non lu(s)").replace("{n}", String(count));
  return (
    <span className="chip text-[10px] font-semibold shrink-0 whitespace-nowrap" style={{ background: "var(--yalola-primary)", color: "#fff" }} data-testid={testId} data-count={count}>{text}</span>
  );
};
